import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=93498e74&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93498e74')) {
      api.createRecord('93498e74', component.options)
    } else {
      api.reload('93498e74', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=93498e74&", function () {
      api.rerender('93498e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MyO19oPd7TdI/JS/comp/ImgFallback2.vue"
export default component.exports